import moment from 'moment';

export const buildInvoiceToLinkGlobal = async () => {
  const largeSize = 15;
  const defaultSize = 12;
  const smallSize = 11;
  const space = [3, 3, 3, 3];

  const Linelayout = {
    hLineWidth: function (i, node) {
      return i === 0 || i === node.table.body.length ? 0 : 1;
    },
    vLineWidth: function (i, node) {
      return 0;
    },
  };

  const content = [];

  content.push({
    table: {
      widths: [335, 335],
      body: [[{ text: 'Invoice', bold: true, fontSize: 28 }]],
    },
    layout: Linelayout,
  });

  content.push({
    text: '\n',
  });

  content.push({
    table: {
      widths: [335, 300],
      body: [
        [
          {
            table: {
              widths: [300, 200],
              body: [
                [
                  {
                    ul: [
                      {
                        text: 'Link Global Recruitment Ltd',
                        listType: 'none',
                        margin: [0, 0, 0, 10],
                      },
                      { text: '61 Bridge Street, Kington', listType: 'none' },
                      { text: 'United Kingdom', listType: 'none' },
                      { text: 'HR5 3DJ', listType: 'none' },
                    ],
                    margin: [-15, 10, 0, 10],
                  },
                ],
              ],
            },
            layout: Linelayout,
          },
          {
            table: {
              widths: [300, 200],
              body: [
                [
                  {
                    ul: [
                      {
                        text: [
                          `Invoice Reference: `,
                          {
                            text: `LG-${moment().subtract(0, 'year').format('YYYY')}`,
                            bold: true,
                          },
                        ],
                        listType: 'none',
                      },
                      {
                        text: `Invoice Date: ${moment().format('YYYY-MM-DD')}`,
                        listType: 'none',
                      },
                    ],
                    margin: [-15, 10, 0, 10],
                  },
                ],
              ],
            },
            layout: Linelayout,
          },
        ],
      ],
    },
    layout: Linelayout,
  });

  content.push({
    table: {
      widths: ['*', 95],
      body: [
        [
          { text: 'Description', margin: space, fillColor: '#ddd' },
          {
            text: 'Amount',
            alignment: 'right',
            margin: space,
            fillColor: '#ddd',
          },
        ],
        [
          {
            text: `Annual professional fee for maintaining Link Global recruitment management system (01/${moment().subtract(0, 'year').format('YYYY')} - 01/${moment().add(1, 'year').format('YYYY')})`,
            margin: space,
          },
          { text: `£1,500.00`, alignment: 'right', margin: space },
        ],
      ],
    },
    margin: [5, 0, 0, 20],
  });

  content.push({
    text: '\n\n',
  });

  content.push({
    table: {
      widths: [300, 335],
      body: [
        [
          {
            table: {
              widths: [400],
              body: [
                [
                  {
                    ul: [
                      {
                        text: `PAYMENT TERMS - 7 DAYS`,
                        listType: 'none',
                        bold: true,
                        fontSize: largeSize,
                      },
                      { text: '\n', listType: 'none', margin: [0, 0, 0, 5] },
                      {
                        text: 'Santander',
                        listType: 'none',
                        bold: true,
                        fontSize: 13,
                      },
                      {
                        text: 'Name: Mr Yi Liu',
                        listType: 'none',
                        bold: true,
                        fontSize: smallSize,
                      },
                      {
                        text: `Sort Code: 09-01-29`,
                        listType: 'none',
                        bold: true,
                        fontSize: smallSize,
                      },
                      {
                        text: `Account Number: 00733960`,
                        listType: 'none',
                        bold: true,
                        fontSize: smallSize,
                      },
                    ],
                    margin: [-15, 30, 0, 10],
                  },
                ],
              ],
            },
            layout: Linelayout,
          },
          {
            table: {
              widths: [400],
              body: [
                [
                  {
                    table: {
                      widths: [95, 95],
                      body: [
                        [
                          { text: 'Net', margin: space, fillColor: '#eee' },
                          {
                            text: `£1,500.00`,
                            alignment: 'right',
                            margin: space,
                          },
                        ],
                        [
                          {
                            text: `VAT 0.00%`,
                            margin: space,
                            fillColor: '#eee',
                          },
                          { text: `0.00`, alignment: 'right', margin: space },
                        ],
                        [
                          { text: `Total`, margin: space, fillColor: '#eee' },
                          {
                            text: `£1,500.00`,
                            alignment: 'right',
                            margin: space,
                            bold: true,
                          },
                        ],
                      ],
                    },
                  },
                ],
              ],
            },
            margin: [-10, 30, 0, 0],
            layout: Linelayout,
          },
        ],
      ],
    },
    layout: Linelayout,
  });

  return {
    pageSize: 'A4',
    defaultStyle: {
      fontSize: defaultSize,
    },
    content,
    footer: function (currentPage, pageCount) {
      return {
        ul: [
          { text: 'Yi Liu', listType: 'none' },
          { text: 'Email: helloyi621@googlemail.com', listType: 'none' },
        ],
        alignment: 'right',
        fontSize: 8,
        margin: [0, -20, 15, 0],
        width: '*',
      };
    },
  };
};
